import React, { Component } from 'react';

import ReactTable from 'react-table';

import 'react-table/react-table.css';

import MenuItem from 'material-ui/MenuItem';
import { Badge, Row, Col } from 'antd';

import OptionsDropdown from 'components/shared/OptionsDropdown';

import { startsWith } from 'helpers/StringHelper';
import { colors, badgeColors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';
import { featureEnabled } from 'helpers/ToggleBot';

class PropertiesTable extends Component {
  constructor(props) {
    super(props);
    const tableSize = props.data && props.data.length > 0 ? props.data.length : 4;
    this.state = {
      tableSize,
      data: this.props.data,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState(
      {
        tableSize: nextProps.data.length === 0 ? 5 : nextProps.data.length,
        data: nextProps.data,
      },
      function () {
        this.forceUpdate();
      }
    );
  }

  render() {
    const columns = [
      {
        header: getTranslatedString('landlordPortal.properties.propertyTable.propertyName'),
        headerClassName: 'headerColumn',
        accessor: 'name',
      },
      {
        header: getTranslatedString('landlordPortal.properties.propertyTable.totalUnits'),
        headerClassName: 'headerColumn',
        accessor: 'unit_count',
      },
      {
        header: getTranslatedString('landlordPortal.properties.propertyTable.siteName'),
        headerClassName: 'headerColumn',
        accessor: 'site_name',
      },
      {
        header: getTranslatedString('landlordPortal.properties.propertyTable.ownerPortfolio'),
        headerClassName: 'headerColumn',
        accessor: 'owner_or_portfolio',
      },
      {
        header: getTranslatedString('landlordPortal.properties.propertyTable.paymentsConnected'),
        accessor: 'payments_connected',
        render: (row) => (row.value ? 'Yes' : 'No'),
      },
      {
        header: getTranslatedString('landlordPortal.properties.propertyTable.uniqueId'),
        accessor: 'unique_id',
        width: 0,
        show: false,
      },
      {
        header: '',
        headerClassName: 'actions',
        render: (row) => (
          <OptionsDropdown
            allowedOpen={
              !this.props.abstractDialogVisible &&
              !this.props.showDeleteDialog &&
              !this.props.showInvitableDialog &&
              !this.props.showDocumentDialogs &&
              !this.props.showMaintenanceWaiverMessageDialog &&
              !this.props.showProspectMessageDialog &&
              !this.props.showGoogleReviewDialog &&
              !this.props.showLegalNoticesDialog &&
              !this.props.showRequestAssistanceDialog
            }
          >
            <MenuItem
              primaryText={
                row.row.editable
                  ? getTranslatedString('landlordPortal.properties.propertyTable.editProperty')
                  : getTranslatedString('landlordPortal.properties.propertyTable.viewProperty')
              }
              onClick={() => this.props.propertyDetails(row.row.id)}
              style={{ fontSize: '14px' }}
            />
            <MenuItem
              primaryText={getTranslatedString(
                'landlordPortal.properties.propertyTable.viewBookingLink'
              )}
              onClick={() => this.props.openAbstractDialog('bookingLink', row.row)}
              style={{ fontSize: '14px' }}
            />
            <MenuItem
              primaryText={getTranslatedString(
                'landlordPortal.properties.propertyTable.viewAppLink'
              )}
              onClick={() => this.props.openAbstractDialog('applicationLink', row.row)}
              style={{ fontSize: '14px' }}
            />
            <MenuItem
              primaryText={
                row.row.invitable
                  ? getTranslatedString('landlordPortal.properties.turnOffInvitations')
                  : getTranslatedString('landlordPortal.properties.enableInvitations')
              }
              onClick={() => this.props.toggleInvitableDialog(row.row.id, row.row.invitable)}
              style={{ fontSize: '14px' }}
            />
            <MenuItem
              primaryText={getTranslatedString(
                'landlordPortal.properties.propertyTable.assignPortfolio'
              )}
              onClick={() => this.props.openAbstractDialog('assignToPortfolio', row.row)}
              style={{ fontSize: '14px' }}
            />
            <MenuItem
              primaryText={getTranslatedString(
                'landlordPortal.properties.propertyTable.assignBank'
              )}
              onClick={() => this.props.openAbstractDialog('assignToBankAccount', row.row)}
              style={{ fontSize: '14px' }}
            />
            <MenuItem
              primaryText={getTranslatedString(
                'landlordPortal.properties.propertyTable.viewPropertyDocs'
              )}
              onClick={() => this.props.openPropertyDocuments(row.row.id)}
              style={{ fontSize: '14px' }}
            />
            <MenuItem
              primaryText={getTranslatedString(
                'landlordPortal.properties.propertyTable.uploadPropertyDocs'
              )}
              onClick={() => {
                this.props.toggleDocumentUploaderDialog(row.row.id);
              }}
              style={{ fontSize: '14px' }}
            />
            <MenuItem
              primaryText={getTranslatedString(
                'landlordPortal.properties.maintenanceDialogForResidents'
              )}
              onClick={() => this.props.toggleMaintenanceWaiverMessageDialog(row.row.id)}
              style={{ fontSize: '14px' }}
            />
            <MenuItem
              primaryText={getTranslatedString(
                'landlordPortal.properties.applicationDialogForProspects'
              )}
              onClick={() => this.props.toggleProspectMessageDialog(row.row.id)}
              style={{ fontSize: '14px' }}
            />
            {this.props.admin && featureEnabled('maintenance.maintenance_dispatch') && (
              <MenuItem
                onClick={() => this.props.openAbstractDialog('maintenance_dispatch', row.row)}
                style={{ fontSize: '14px' }}
                disabled={!row.row.maintenance_dispatch && !row.row.zone_lead_present}
              >
                <p>
                  {getTranslatedString(
                    `landlordPortal.properties.maintenanceDispatch.${
                      !row.row.maintenance_dispatch ? 'enable' : 'disable'
                    }`
                  )}
                </p>
                {!row.row.maintenance_dispatch && !row.row.zone_lead_present && (
                  <div style={{ lineHeight: '1.6', marginTop: '-20px' }}>
                    {' '}
                    {/** the -20px offsets the lineHeight in the title string */}
                    <Row>
                      <Col span={2}>
                        <Badge dot color={badgeColors.YELLOW} />
                      </Col>
                      <Col span={22}>
                        <p style={{ whiteSpace: 'normal', maxWidth: '300px' }}>
                          {getTranslatedString(
                            'landlordPortal.properties.maintenanceDispatch.zoneLeadText'
                          )}
                        </p>
                      </Col>
                    </Row>
                  </div>
                )}
              </MenuItem>
            )}
            {this.props.admin && this.props.googleEnabled && (
              <MenuItem
                primaryText={getTranslatedString(
                  `landlordPortal.properties.googleReviews.${
                    !row.row.google_reviews_active ? 'enable' : 'disable'
                  }`
                )}
                onClick={() => this.props.toggleGoogleReviewDialog(row.row.id)}
                style={{ fontSize: '14px' }}
              />
            )}
            {featureEnabled('legal_documents_as_notices') && this.props.legalNoticesEnabled && (
              <MenuItem
                primaryText={getTranslatedString(
                  `landlordPortal.properties.digitalLegalNotices.${
                    !row.row.can_send_legal_notices ? 'enable' : 'disable'
                  }`
                )}
                onClick={() => this.props.toggleLegalNoticesDialog(row.row.id)}
                style={{ fontSize: '14px' }}
              />
            )}
            {featureEnabled('ui.residents.request_assistance') && this.props.requestAssistanceEnabled && (
              <MenuItem
                primaryText={getTranslatedString(
                  `landlordPortal.properties.requestAssistance.${
                    row.row.enable_portal_assistance_request ? 'disable' : 'enable'
                  }Title`
                )}
                onClick={() => this.props.toggleRequestAssistanceDialog(row.row.id)}
                style={{ fontSize: '14px' }}
              />
            )}
            {this.props.admin && (
              <MenuItem
                primaryText={getTranslatedString(
                  'landlordPortal.properties.propertyTable.inactivateProperty'
                )}
                onClick={() => this.props.toggleDeleteDialog(row.row.id)}
                style={{ color: colors.RED, fontSize: '14px' }}
              />
            )}
          </OptionsDropdown>
        ),
      },
    ];

    return (
      <div style={{ marginBottom: '70px' }}>
        <ReactTable
          data={this.state.data}
          columns={columns}
          showFilters={false}
          showPagination={false}
          showPageSizeOptions={false}
          pageSize={this.state.tableSize}
          defaultFilterMethod={(filter, row, column) => {
            const id = filter.pivotId || filter.id;
            return row[id] !== undefined
              ? startsWith(String(row[id]).toLowerCase(), filter.value)
              : true;
          }}
          noDataText={getTranslatedString('landlordPortal.properties.propertyTable.noProperties')}
        />
      </div>
    );
  }
}

export default PropertiesTable;
